import { makeAutoObservable } from "mobx";
import { components } from "../../../../../api/spec";
import {
  sitchEventAddManualSetupToRound,
  sitchEventRemoveManualSetupFromRound,
  sitchEventListCandidatesForRound,
  sitchEventListAttendees,
  // TODO: add this back
  // sitchEventListRoundCandidatesForMember,
} from "../../../../../api/sitch_events";
import EventStore from "../../event/store/eventStore";

export class ManualMatchStore {
  searchQuery = "";

  selectedGuests: string[] = [];

  attendees: components["schemas"]["EventAttendeeSummarySchema"][] = [];

  candidates: components["schemas"]["EventCandidateSummarySchema"][] = [];

  constructor() {
    makeAutoObservable(this);
  }

  loadAttendees = async (eventGuid: string) => {
    try {
      const result = await sitchEventListAttendees(eventGuid);
      this.attendees = result.attendees || [];
    } catch (err) {
      console.log(err);
    }
  };

  loadCandidates = async (roundGuid: string) => {
    try {
      this.candidates = await sitchEventListCandidatesForRound(roundGuid, true);
    } catch (err) {
      console.log(err);
    }
  };

  get filteredAttendees() {
    return this.attendees.filter((attendee) =>
      (attendee.full_name || "")
        .toLowerCase()
        .includes(this.searchQuery.toLowerCase()),
    );
  }

  setSearchQuery = (query: string) => {
    this.searchQuery = query;
  };

  toggleGuestSelection = (guestId: string) => {
    if (this.selectedGuests.includes(guestId)) {
      this.selectedGuests = this.selectedGuests.filter((id) => id !== guestId);
    } else if (this.selectedGuests.length < 2) {
      this.selectedGuests.push(guestId);
    }
  };

  clearSelection = () => {
    this.selectedGuests = [];
  };

  createManualSetup = async () => {
    if (!EventStore.sitchEventData?.current_round) return;

    try {
      const response = await sitchEventAddManualSetupToRound({
        round: EventStore.sitchEventData.current_round,
        user_1: this.selectedGuests[0],
        user_2: this.selectedGuests[1],
      });

      if (response.success && response.candidate) {
        this.candidates.push(response.candidate);
      }

      this.attendees = this.attendees.filter(
        (attendee) =>
          !this.candidates.some(
            (c) =>
              c.user_1_guid === attendee.guid ||
              c.user_2_guid === attendee.guid,
          ),
      );

      this.selectedGuests = [];
    } catch (err) {
      console.log(err);
    }
  };

  removeManualMatch = async (candidateId: string) => {
    if (!EventStore.sitchEventData?.current_round) return;

    try {
      const response = await sitchEventRemoveManualSetupFromRound({
        round: EventStore.sitchEventData.current_round,
        candidate: candidateId,
      });

      if (response.success && EventStore.sitchEventData?.guid) {
        this.candidates = this.candidates.filter((c) => c.guid !== candidateId);
        await this.loadAttendees(EventStore.sitchEventData.guid);
      }
    } catch (err) {
      console.log(err);
    }
  };
}

export default new ManualMatchStore();
